module.exports = __webpack_public_path__ + "media/images/bannerImage3-b92c80825009501b782209a0a4a6935c.jpg";